// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    file: path(ROOTS_DASHBOARD, '/file'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/user/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  service: {
    root: path(ROOTS_DASHBOARD, '/service'),
    new: path(ROOTS_DASHBOARD, '/service/new'),
    list: path(ROOTS_DASHBOARD, '/service/list'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/service/${id}/edit`),
  },
  partner: {
    root: path(ROOTS_DASHBOARD, '/partner'),
    new: path(ROOTS_DASHBOARD, '/partner/new'),
    list: path(ROOTS_DASHBOARD, '/partner/list'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/partner/${id}/edit`),
  },
  brand: {
    root: path(ROOTS_DASHBOARD, '/brand'),
    new: path(ROOTS_DASHBOARD, '/brand/new'),
    list: path(ROOTS_DASHBOARD, '/brand/list'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/brand/${id}/edit`),
    items: (id: string) => path(ROOTS_DASHBOARD, `/brand/${id}/items`),
    photos: (id: string) => path(ROOTS_DASHBOARD, `/brand/${id}/photos`),
  },
  message: {
    root: path(ROOTS_DASHBOARD, '/message'),
    list: path(ROOTS_DASHBOARD, '/message/list'),
  },
  contactInfo: {
    root: path(ROOTS_DASHBOARD, '/contact/info'),
    edit: path(ROOTS_DASHBOARD, '/contact/info'),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/blog/post/${id}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  event: {
    root: path(ROOTS_DASHBOARD, '/event'),
    new: path(ROOTS_DASHBOARD, `/event/new`),
    list: path(ROOTS_DASHBOARD, '/event/list'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/event/${id}/edit`),
    extend: (id: string) => path(ROOTS_DASHBOARD, `/event/${id}/extend`),
    view: (id: string) => path(ROOTS_DASHBOARD, `/event/${id}`),
    viewDay: (id: string, dayId: string) => path(ROOTS_DASHBOARD, `/event/${id}/day/${dayId}`),
    reservation: (id: string, stateType?: string) =>
      path(ROOTS_DASHBOARD, `/event/${id}/reservations/${stateType}`),
    deletedReservations: (id: string) => path(ROOTS_DASHBOARD, `/event/${id}/deleted-reservations`),
    canceledReservations: (id: string) =>
      path(ROOTS_DASHBOARD, `/event/${id}/cancelled-reservations`),
    calender: (id: string) => path(ROOTS_DASHBOARD, `/event/${id}/calender`),
  },
  performance: {
    root: path(ROOTS_DASHBOARD, '/performance'),
    new: path(ROOTS_DASHBOARD, '/performance/new'),
    list: path(ROOTS_DASHBOARD, '/performance/list'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/performance/${id}/edit`),
  },
  hdyku: {
    root: path(ROOTS_DASHBOARD, '/hdyku'),
    list: path(ROOTS_DASHBOARD, '/hdyku/list'),
  },
  neighborhood: {
    root: path(ROOTS_DASHBOARD, '/neighborhood'),
    list: path(ROOTS_DASHBOARD, '/neighborhood/list'),
  },
  coupon: {
    root: path(ROOTS_DASHBOARD, '/coupon'),
    list: path(ROOTS_DASHBOARD, '/coupon/list'),
    stats: path(ROOTS_DASHBOARD, '/coupon/stats'),
  },
  reservation: {
    root: path(ROOTS_DASHBOARD, `/reservation`),
    new: (eventId?: string) => path(ROOTS_DASHBOARD, `/reservation/new?eventId=${eventId}`),
  },
  mange: {
    root: path(ROOTS_DASHBOARD, `/mange`),
  },
  policy: {
    root: path(ROOTS_DASHBOARD, `/policy`),
    list: path(ROOTS_DASHBOARD, `/policy`),
    new: path(ROOTS_DASHBOARD, `/policy/create`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/policy/update/${id}`),
  },
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
